import React from "react";
import clsx from "clsx";
import { Link, useHistory } from "react-router-dom";
import { Box } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { Logo } from "../../../assets/images";
import SearchBar from "../../SearchBar";
import Hidden from "@material-ui/core/Hidden";
import { useStyles } from "./../styles";
import {
  USERS,
  DASHBOARD,
  TARGET,
  VISION,
  CHECKIN,
  COMPANY,
  REPORTS,
} from "../../../constants/routeConstants";
import HeaderNotificationsSection from "./HeaderNotificationsSection";
import MobileHeaderSection from "./MobileHeaderSection";
import ProfileMenu from "./ProfileMenu";
import PageTitle from "Components/formControls/HookFields/PageTitle";

const Header = ({
  isDrawerOpen,
  menuId,
  handleMobileMenuOpen,
  handleProfileMenuOpen,
  mobileMenuId,
  userDetails,
  isCompanySetupCompleted,
  refreshHeader,
}) => {
  const classes = useStyles();
  const history = useHistory();

  const getHeaderText = () => {
    // TODO: Handle header text based on page rendered and not on route
    if (!isCompanySetupCompleted) return "Organization Setup";
    const location = history.location.pathname;
    if (location.includes(USERS)) return "Users";
    if (location.includes(TARGET)) return "Targets";
    if (location.includes("user-profile")) return "User Profile";
    if (location.includes(VISION)) return "Vision";
    if (location.includes(CHECKIN)) return "Check-in Templates";
    if (location.includes(COMPANY)) return "Organization Settings";
    if (location.includes(REPORTS)) return "Reports";
    if (location.includes(DASHBOARD)) return "Dashboard";
  };

  return (
    <AppBar
      position="fixed"
      color="inherit"
      elevation={0}
      className={clsx(classes.appBar, {
        [classes.appBarShift]: isDrawerOpen,
        [classes.companySetupHeader]: !isCompanySetupCompleted,
      })}
    >
      <Toolbar>
        <Hidden xsDown>
          <Box className={classes.grow} display="flex">
            <Link to={"/"} style={{ textDecoration: "none" }}>
              <img src={Logo} alt="logo" className={classes.logo} />
            </Link>
          </Box>
        </Hidden>
        <Hidden smUp>
          <Box className={classes.grow} display="flex">
            <PageTitle title={getHeaderText()} />
          </Box>
        </Hidden>

        {isCompanySetupCompleted && <SearchBar refreshHeader={refreshHeader} />}

        <div className={classes.sectionDesktop}>
          {isCompanySetupCompleted && <HeaderNotificationsSection />}
          <ProfileMenu
            menuId={menuId}
            handleProfileMenuOpen={handleProfileMenuOpen}
            userDetails={userDetails}
          />
        </div>
        <MobileHeaderSection
          handleMobileMenuOpen={handleMobileMenuOpen}
          mobileMenuId={mobileMenuId}
          isCompanySetupCompleted={isCompanySetupCompleted}
        />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
